import script from "./CreateDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./CreateDocuments.vue?vue&type=style&index=0&id=20713db8&lang=scss"

const __exports__ = script;

export default __exports__